import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const invoiceGetNextDocumentNumberAtom = createMutationAtomFactory(
  'finance.invoiceGetNextDocumentNumber',
  () => ({
    financeNextInvoiceDocumentNumber: true,
  }),
);
